import React, { useCallback, useEffect, useState } from 'react'
import Versions from './Versions'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getVersionOptionsFetch, getVersionWordsFetch, getWorngVersionWordsFetch } from 'store/middlewares/assessment.crud'
import qc from 'keys/queryClient'
import { useParams } from 'react-router-dom'
import { types } from 'keys'
import { MarkingWordsAssessmentVM, WordVM } from 'models/VM'
import { keyBy } from 'lodash'

const VersionsPage = () => {
    const [version1, setVersion1] = useState(null)
    const [version2, setVersion2] = useState(null)
    const [wrongWords1, setWrongWords1] = useState(null)
    const [wrongWords2, setWrongWords2] = useState(null)
    const queryClient = useQueryClient()

    const params = useParams()
    let assessmentID = params.assessmentID

    const versions = useQuery({
        queryKey: [qc.versionOptions],
        queryFn: async () => {
            const versions = await getVersionOptionsFetch(assessmentID)
            return versions.data
        }
    })


    const assessmentVersion1 = useQuery({
        queryKey: [qc.assessmentVersion, version1?.id || ''],
        queryFn: async () => {
            const versions = await getVersionWordsFetch(version1?.id)
            const assessment = versions.data
            const mWords = []
            assessment.words.forEach((word, index) => mWords.push(new WordVM({ assessment: assessment, ...word }, index)))
            const assessmentData = { ...versions.data, words: mWords }
            if (assessmentVersion2.data)
                updateWrongWords(assessmentData, assessmentVersion2.data)
            return assessmentData
        },
        enabled: !!version1
    })

    const assessmentVersion2 = useQuery({
        queryKey: [qc.assessmentVersion, version2?.id || ''],
        queryFn: async () => {
            const versions = await getVersionWordsFetch(version2?.id)
            const assessment = versions.data
            const mWords = []
            assessment.words.forEach((word, index) => mWords.push(new WordVM({ assessment: assessment, ...word }, index)))
            const assessmentData = { ...versions.data, words: mWords }
            if (assessmentVersion1.data)
                updateWrongWords(assessmentData, assessmentVersion1.data)
            return assessmentData
        },
        enabled: !!version2
    })

    const updateWrongWords = useCallback((version1, version2) => {
        if (version1?.words && version2?.words) {
            const words1 = []
            const words2 = []

            for (let i = 0; i < version1?.words.length; i++) {
                const word1 = version1?.words[i]
                const word2 = version2?.words[i]

                if (word1.status && word2.status)
                    if (word1.status != types.correct || word2.status != types.correct) {
                        words1.push(word1)
                        words2.push(word2)
                    }
                    else if (word1.errors?.length || word2.errors?.length) {
                        words1.push(word1)
                        words2.push(word2)
                    }
            }
            setWrongWords1(words2)
            setWrongWords2(words1)
        }
    }, [assessmentVersion1, assessmentVersion2])

    const commonValue = {
        version1, setVersion1,
        version2, setVersion2,
        assessmentVersion1,
        assessmentVersion2,
        wrongWords1, setWrongWords1,
        wrongWords2, setWrongWords2
    }

    return (
        <VersionsContext.Provider value={commonValue}>
            <Versions versions={versions} Context={VersionsContext} />
        </VersionsContext.Provider>
    )
}

export const VersionsContext = React.createContext()

export default VersionsPage